module.exports = __webpack_public_path__ + "img/A58A1265.8fc99880.jpg";